import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import { useLocation } from "react-router-dom";
function NavbarContainer() {
  // 1- Get the size of window
  const windowInnerSize = [window.innerWidth, window.innerHeight];
  let [isMobileView, setMobileView] = useState(false);
  let location = useLocation();
  // 2- Define the state variable windowSize and pass windowInnerSize as its initial value
  const [windowSize, setWidowSize] = useState(windowInnerSize);
  const [showLanguages, setShowLanguages] = useState(false);
  const languageFilterRef = useRef(null);

  useEffect(() => {
    const changeWindowSize = () => {
      setWidowSize([window.innerWidth, window.innerHeight]);
    };
    /* 3- add a 'resize' eventListener to window
           so whenever the size of window changes
        the state variable windowSize changes and the component  re-renders */
    window.addEventListener("resize", changeWindowSize);

    // 4- cleanup the 'resize' eventListener
    return () => window.removeEventListener("resize", changeWindowSize);
  }, []);
  const handleShowLanguages = () => {
    setShowLanguages(!showLanguages);
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        showLanguages &&
        languageFilterRef?.current &&
        !languageFilterRef.current.contains(event.target) &&
        event.target.id !== "language-filter"
      ) {
        setShowLanguages(false);
      }
    };

    if (showLanguages) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showLanguages]);

  console.log(showLanguages, "showLanguages");
  const [width, height] = windowSize;

  return (
    <Header
      width={width}
      height={height}
      isMobileView={isMobileView}
      setMobileView={setMobileView}
      languageFilterRef={languageFilterRef}
      handleShowLanguages={handleShowLanguages}
    ></Header>
  );
}

export default NavbarContainer;
